/**
 * Live industry lists keyed by GICS sector — local round-robin source (AD-11).
 *
 * Retired catalog rows are omitted: local names may differ from HTTP, but they
 * must never invent a fifth RNG stream or a synthetic catalog.
 */
import { AreaIdSchema, INDUSTRY_CATALOG, type AreaId, type SectorId } from '@meridian/contracts';

function liveIdsFor(sectorId: SectorId): readonly AreaId[] {
  return Object.freeze(
    INDUSTRY_CATALOG.filter((row) => row.sectorId === sectorId && row.retiredIn === undefined).map(
      (row) => AreaIdSchema.parse(row.id),
    ),
  );
}

export const INDUSTRIES_BY_SECTOR: Readonly<Record<SectorId, readonly AreaId[]>> = Object.freeze({
  TEC: liveIdsFor('TEC'),
  COM: liveIdsFor('COM'),
  DIS: liveIdsFor('DIS'),
  STA: liveIdsFor('STA'),
  FIN: liveIdsFor('FIN'),
  HLT: liveIdsFor('HLT'),
  IND: liveIdsFor('IND'),
  ENE: liveIdsFor('ENE'),
  UTL: liveIdsFor('UTL'),
  REI: liveIdsFor('REI'),
  MAT: liveIdsFor('MAT'),
});

export function liveIndustryName(id: AreaId): string {
  const row = INDUSTRY_CATALOG.find((r) => r.id === id);
  return row?.name ?? id;
}

export function isLiveIndustryId(id: string): id is AreaId {
  return Object.values(INDUSTRIES_BY_SECTOR).some((ids) => ids.some((item) => item === id));
}
